import api from 'api';
import useAlerts from './useAlerts';
import useLoaders from './useLoaders';

const { default: useResource } = require('./useResource');

const useAcademies = ({ id, defaultSortKey, defaultSortDirection }) => {
	const RESOURCE_URL = '/api/v1/admin/academies';
	const { showAlertError, showAlertSuccess } = useAlerts();
	const { setIsLoading } = useLoaders();

	const {
		handleChange,
		isLoading,
		isLoaded,
		isEmpty,
		deleteFile,
		uploadFile,
		id: academyId,
		resource: academy,
		resources: academies,
		create: createAcademy,
		findMany: findAcademies,
		findOne: findAcademy,
		update: updateAcademy,
		findMany: reloadAcademies,
		destroy: deleteAcademy,
		setResource: setAcademy
	} = useResource({
		id: id,
		url: RESOURCE_URL,
		name: 'academy',
		defaultSortKey: defaultSortKey,
		defaultSortDirection: defaultSortDirection
	});

	const resortAcademyEvents = (events) => {
		const sorted = events.map((item) => ({
			id: item.id,
			position: item.position
		}));
		api.post(`/api/v1/admin/academies/${academy.id}/events/resort`, {
			events: sorted
		});
		return sorted;
	};

	const regenerateInvitationCode = () => {
		setIsLoading(true);
		return api
			.post(`/api/v1/admin/academies/${academy.id}/regenerate_code`)
			.then((response) => {
				showAlertSuccess('Invitation code regenerated successfully.');
				findAcademy(academy.id);
			})
			.catch((error) => {
				showAlertError('Error regenerating invitation code.');
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	return {
		handleChange,
		isLoaded,
		isLoading,
		isEmpty,
		academies,
		academy,
		academyId,
		createAcademy,
		findAcademies,
		findAcademy,
		deleteFile,
		uploadFile,
		updateAcademy,
		reloadAcademies,
		deleteAcademy,
		resortAcademyEvents,
		regenerateInvitationCode,
		setAcademy
	};
};

export default useAcademies;
